module.exports = __webpack_public_path__ + "static/img/irole.5c50c14.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/mx/irole.png
// module id = ejcg
// module chunks = 7